import angular from 'angular';

import tszCompanySubscriptions from './tsz-company-subscriptions';

const tszCompanySubscriptionsModule = angular.module('tsz.components.tszCompanySubscriptions', [])
  .component('tszCompanySubscriptions', tszCompanySubscriptions);

export default tszCompanySubscriptionsModule;



// WEBPACK FOOTER //
// ./src/components/tsz-company-subscriptions/tsz-company-subscriptions.module.js